export const ViewButton = ({ onView }) => {
  return <div onClick={onView}>View</div>;
};
